var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/flash-on.ad9fb759.png","uri@2x": __webpack_public_path__ + "static/media/flash-on.c51b55dd.png","uri@3x": __webpack_public_path__ + "static/media/flash-on.9b8db79a.png",
    width: 12,
    height: 19
});